import React, { createContext, useContext, useState, useEffect } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [listaempresa, setListaEmpresa] = useState(() => {
    return JSON.parse(localStorage.getItem("listaempresa") || "[]");
  });

  const [accessKey, setAccessKey] = useState(() => {
    return localStorage.getItem("accessKey") || "";
  });

  const [codempresa, setCodEmpresa] = useState(() => {
    return parseInt(localStorage.getItem("codempresa")) || 0;
  });

  const [licenca, setLicenca] = useState(() => {
    return localStorage.getItem("licenca") || false;
  });

  const [codassinante, setCodAssinante] = useState(() => {
    return parseInt(localStorage.getItem("codassinante")) || 0;
  });

  const [codusuario, setCodUsuario] = useState(() => {
    return parseInt(localStorage.getItem("codusuario")) || 0;
  });

  const [perfil, setPerfil] = useState(() => {
    return JSON.parse(localStorage.getItem("perfilUsuario") || "[]");
  });

  const [usuario, setUsuario] = useState(() => {
    return localStorage.getItem("usuario") || "";
  });

  // Salva automaticamente toda mudança no localStorage
  useEffect(() => {
    localStorage.setItem("listaempresa", JSON.stringify(listaempresa));
  }, [listaempresa]);

  useEffect(() => {
    localStorage.setItem("accessKey", accessKey);
  }, [accessKey]);

  useEffect(() => {
    localStorage.setItem("codempresa", codempresa);
  }, [codempresa]);

  useEffect(() => {
    localStorage.setItem("licenca", licenca);
  }, [licenca]);

  useEffect(() => {
    localStorage.setItem("codassinante", codassinante);
  }, [codassinante]);

  useEffect(() => {
    localStorage.setItem("codusuario", codusuario);
  }, [codusuario]);

  useEffect(() => {
    localStorage.setItem("usuario", usuario);
  }, [usuario]);

  useEffect(() => {
    localStorage.setItem("perfilUsuario", JSON.stringify(perfil));
  }, [perfil]);

  // Apenas salva as empresas + token
  const updateLoginData = (empresas, token) => {
    setListaEmpresa(empresas);
    setAccessKey(token);
  };

  const limparContexto = () => {
    setListaEmpresa([]);
    setAccessKey("");
    setCodEmpresa(0);
    setLicenca(false);
    setCodAssinante(0);
    setCodUsuario(0);
    setPerfil([]);
    setUsuario("");

    // opcional, mas altamente recomendado
    localStorage.clear();
  };

  return (
    <AppContext.Provider
      value={{
        listaempresa,
        accessKey,
        codempresa,
        codassinante,
        codusuario,
        usuario,
        licenca,
        perfil,

        setLicenca,
        setUsuario,
        setAccessKey,
        setCodEmpresa,
        setCodAssinante,
        setCodUsuario,
        setPerfil,
        updateLoginData,
        limparContexto
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
